import { FilterDisplayType, FilterProperties, FilterValue } from '@/entities/catalog-old'

import { AppliedFilterBlock } from '../types/types'

// Rank a value for the dropdown order: checked (selected) first, then available (has products), then
// unavailable (zero count — rendered disabled). Array.sort is stable, so within each group the values
// keep their incoming server SORT order.
const valueRank = (value: FilterValue): number => {
	if (value.CHECKED) return 0
	if (value.ELEMENT_COUNT > 0) return 1
	return 2
}

// Build the per-block view of the currently applied filters. One block per property that has at
// least one checked value. List blocks (checkbox display with more than one option) get a dropdown
// so the user can toggle values right from the chip; single-value toggles (В наличии, Участвует в
// акциях), Radio blocks and the price range are chips with just a remove action.
export const getAppliedFilterBlocks = (properties: FilterProperties[]): AppliedFilterBlock[] =>
	properties?.reduce<AppliedFilterBlock[]>((acc, prop) => {
		const hasChecked = prop.VALUES?.some(v => v.CHECKED)
		if (!hasChecked) return acc

		const hasDropdown =
			prop.CODE !== 'PRICE' && prop.DISPLAY_TYPE === FilterDisplayType.CheckBox && prop.VALUES.length > 1

		acc.push({
			code: prop.CODE,
			name: prop.NAME,
			displayType: prop.DISPLAY_TYPE,
			hasDropdown,
			values: [...prop.VALUES].sort((a, b) => valueRank(a) - valueRank(b))
		})

		return acc
	}, [])
